export const QUERY_KEYS = {
  PRODUCTS: "products",
  CHECKOUT: "checkout",
  COUNTRIES: "countries",
  STATES: "states",
};
